import { render, staticRenderFns } from "./CustomerRolesComponent.vue?vue&type=template&id=d83f17b6"
import script from "./CustomerRolesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerRolesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports